import React, { useEffect, useRef, useCallback } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
const Faq = () => {
     const revealRefs = useRef([]);
    
        const addRevealRef = useCallback((el) => {
            if (el && !revealRefs.current.includes(el)) {
                revealRefs.current.push(el);
            }
        }, []);
        useEffect(() => {    
            // GSAP Reveal Animation
            revealRefs.current.forEach((container) => {
                const image = container.querySelector('img');
    
                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: container,
                        toggleActions: 'play none none none',
                    },
                });
    
                tl.set(container, { autoAlpha: 1 });
    
                tl.from(container, {
                    // xPercent: -100,
                    duration: 1,
                    ease: 'power2.out',
                });
    
                tl.from(image, {
                    xPercent: 100,
                    scale: 1,
                    delay: -1,
                    duration: 1,
                    ease: 'power2.out',
                });
            });
        }, []);
    return (
        <>
            <div className="our-faqs">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-7">
                            {/* Our Faq Content Start */}
                            <div className="our-faqs-content">
                                {/* Section Title Start */}
                                <div className="section-title">
                                    <h3 className="wow fadeInUp" style={{ fontSize: 25 }}>
                                        asked question
                                    </h3>
                                    <h2 className="text-anime-style-2" data-cursor="-opaque">
                                        Have your any question look <span>here now</span>
                                    </h2>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s">
                                        Nostra turma dedicata consilium arctius operatur ut visionem tuam
                                        intelligat et eam ad vitam adducat cum magna cura in singula
                                    </p>
                                </div>
                                {/* Section Title End */}
                                {/* FAQ Accordion Start */}
                                <div className="faq-accordion" id="accordion">
                                    {/* FAQ Item Start */}
                                    <div className="accordion-item wow fadeInUp">
                                        <h2 className="accordion-header" id="heading1">
                                            <button
                                                className="accordion-button"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapse1"
                                                aria-expanded="true"
                                                aria-controls="collapse1"
                                            >
                                                <span>1.</span> What is the typical process for starting a
                                                design project?
                                            </button>
                                        </h2>
                                        <div
                                            id="collapse1"
                                            className="accordion-collapse collapse show"
                                            aria-labelledby="heading1"
                                            data-bs-parent="#accordion"
                                        >
                                            <div className="accordion-body">
                                                <p>
                                                    Our process starts with a consultation to discuss your
                                                    vision, followed by planning, design presentation, and
                                                    implementation to achieve your ideal space.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* FAQ Item End */}
                                    {/* FAQ Item Start */}
                                    <div className="accordion-item wow fadeInUp" data-wow-delay="0.2s">
                                        <h2 className="accordion-header" id="heading2">
                                            <button
                                                className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapse2"
                                                aria-expanded="false"
                                                aria-controls="collapse2"
                                            >
                                                <span>2.</span> How long does a typical interior design
                                                project take?
                                            </button>
                                        </h2>
                                        <div
                                            id="collapse2"
                                            className="accordion-collapse collapse"
                                            aria-labelledby="heading2"
                                            data-bs-parent="#accordion"
                                        >
                                            <div className="accordion-body">
                                                <p>
                                                    The timeline varies based on the scope and size of the
                                                    project, but most interior design projects are completed
                                                    within 4 to 12 weeks from consultation to final
                                                    installation.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* FAQ Item End */}
                                    {/* FAQ Item Start */}
                                    <div className="accordion-item wow fadeInUp" data-wow-delay="0.4s">
                                        <h2 className="accordion-header" id="heading3">
                                            <button
                                                className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapse3"
                                                aria-expanded="false"
                                                aria-controls="collapse3"
                                            >
                                                <span>3.</span> Can I incorporate my existing furniture into
                                                the new design?
                                            </button>
                                        </h2>
                                        <div
                                            id="collapse3"
                                            className="accordion-collapse collapse"
                                            aria-labelledby="heading3"
                                            data-bs-parent="#accordion"
                                        >
                                            <div className="accordion-body">
                                                <p>
                                                    Yes, we’re happy to work with your existing pieces. We’ll
                                                    evaluate each item and blend it seamlessly into the new
                                                    design to reflect your style and maximize comfort.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* FAQ Item End */}
                                    {/* FAQ Item Start */}
                                    <div className="accordion-item wow fadeInUp" data-wow-delay="0.6s">
                                        <h2 className="accordion-header" id="heading4">
                                            <button
                                                className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapse4"
                                                aria-expanded="false"
                                                aria-controls="collapse4"
                                            >
                                                <span>4.</span> What should I expect during the design
                                                consultation?
                                            </button>
                                        </h2>
                                        <div
                                            id="collapse4"
                                            className="accordion-collapse collapse"
                                            aria-labelledby="heading4"
                                            data-bs-parent="#accordion"
                                        >
                                            <div className="accordion-body">
                                                <p>
                                                    During the consultation, we’ll learn about your lifestyle,
                                                    preferences, and goals. We’ll discuss ideas, assess your
                                                    space, and guide you on the next steps in
                                                    the&nbsp;design&nbsp;process.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* FAQ Item End */}
                                </div>
                                {/* FAQ Accordion End */}
                            </div>
                            {/* Our Faq Content End */}
                        </div>
                        <div className="col-lg-5">
                            {/* Our Faq Image Start */}
                            <div className="our-faqs-image">
                                <figure className="image-anime reveal" ref={addRevealRef} style={{ opacity: 0 }}>
                                    <img src="images/faqs-image.jpg" alt="" />
                                </figure>
                            </div>
                            {/* Our Faq Image End */}
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Faq
